import { __rest } from './../../../external/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { LockOutline } from '@olist/design-system-icons';
import { SuffixIconInputPassword } from './SuffixIconInputPassword.js';
import { Input } from '../Input.js';

const InputPassword = (_a) => {
    var { label, helperText, placeholder } = _a, props = __rest(_a, ["label", "helperText", "placeholder"]);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    return (React.createElement(Input, Object.assign({ type: !isPasswordVisible ? 'password' : 'text', label: label, helperText: helperText, placeholder: placeholder, prefix: LockOutline, required: true, suffix: () => SuffixIconInputPassword(setIsPasswordVisible, isPasswordVisible) }, props)));
};

export { InputPassword as default };
